/* eslint-disable */


var loaded = false;

function init(src, element) {
  if ($(element).length < 1) return;

  var script = document.createElement('script');
  script.src = src;
  document.body.appendChild(script);

  var loader = window.setInterval(function() {
    if (typeof $(element).isitetv_player_api === 'undefined') return;
    $(element).isitetv_player_api({
      onAssetCount: function(count) {
        $(element)[0].className = 'isite-asset-count-' + count;
      },
      onSize: function(size) {
        $(element).height(size.height);
      }
    });
    clearInterval(loader);
    loaded = true;
  }, 100);
}

module.exports = {
  initialise: init,
  play: function(element) {
    if (!loaded) return;
    $(element).isitetv_player_play();
  },
  pause: function(element) {
    if (!loaded) return;
    $(element).isitetv_player_pause();
  },
  getSize: function(element) {
    if (!loaded) return;
    return $(element).isitetv_player_get_size();
  },
  getAssetCount: function(element) {
    if (!loaded) return;
    return $(element).isitetv_player_get_current_asset_count();
  },
  hideLinkForIrelandOnProductPage: function() {
      $('p.isitetv-visibility a').addClass('isitetv-visibility-hidden');
  }
};
